import {
	type BankTransactionUpdateOrderDto,
	patchBanksTransactionsId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { PAYMENT_LIST } from "Payment/Api/Query/usePaymentsQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const paymentMutationsResource = Resources.base.payment.mutation;

export const useUpdatePaymentMutation = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: BankTransactionUpdateOrderDto) =>
			patchBanksTransactionsId(data, data.id!),
		),
		onError: (error) => {
			console.error(
				`${t(paymentMutationsResource.updatePaymentError)}:`,
				error,
			);
			toast.error(t(paymentMutationsResource.updatePaymentError));
		},
		onSuccess: () => {
			toast.success(t(paymentMutationsResource.updatePaymentSuccess));
			queryClient.invalidateQueries({
				queryKey: [PAYMENT_LIST],
			});
		},
	});
};
